import { AuthManager } from '../AuthManager';
import { Headers } from '../types';
import { ApiClientFactory } from './clients';

export class AuthManagerFactory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string, headers: Headers = {}) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/auth`, headers);
  }

  createAuthManager(): AuthManager {
    return new AuthManager(this.apiClientFactory.createClient());
  }
}
